(function () {
    var Contrast = {
        storage: 'contrastState',
        cssClass: 'contrast',
        currentState: null,
        check: checkContrast,
        getState: getContrastState,
        setState: setContrastState,
        toogle: toogleContrast,
        updateView: updateViewContrast
    };

    window.toggleContrast = function () { Contrast.toogle(); };

    Contrast.check();

    function checkContrast() {
        this.updateView();
    }

    function getContrastState() {
        return localStorage.getItem(this.storage) === 'true';
    }

    function setContrastState(state) {
        localStorage.setItem(this.storage, '' + state);
        this.currentState = state;
        this.updateView();
    }

    function updateViewContrast() {
        var body = document.body;

        if (this.currentState === null)
            this.currentState = this.getState();

        if (this.currentState)
            body.classList.add(this.cssClass);
        else
            body.classList.remove(this.cssClass);
    }

    function toogleContrast() {
        this.setState(!this.currentState);
    }
})();
    




function fonte(e){
  var elemento = $("p, h2, h3, h4, h5, h6, span, li, a, table");
  var fonte = elemento.css('font-size');
  if (e == 'a') {
    elemento.css("fontSize", parseInt(fonte) + 1);
  } else if('d'){
    elemento.css("fontSize", parseInt(fonte) - 1);
  }
}


// WEBPACK FOOTER //
// src/assets/js/fonts.js